// Centralized API helper
import logger from './logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const j = await res.json();
      detail = j.detail || j.message || detail;
    } catch (parseErr) {
      // Response body wasn't JSON — log but keep generic detail message
      logger.warn(`[api] Failed to parse error body for ${path}:`, parseErr);
    }
    logger.error(`[api] ${options.method || 'GET'} ${path} -> ${res.status}: ${detail}`);
    throw new Error(detail);
  }
  return res.json();
}

export const api = {
  // forms
  contact: (data) => request('/contact', { method: 'POST', body: JSON.stringify(data) }),
  quote: (data) => request('/quote', { method: 'POST', body: JSON.stringify(data) }),
  newsletter: (data) => request('/newsletter', { method: 'POST', body: JSON.stringify(data) }),
  careerApply: (data) => request('/careers/apply', { method: 'POST', body: JSON.stringify(data) }),
  // analytics
  trackIndustryClick: (data) => request('/track/industry-click', { method: 'POST', body: JSON.stringify(data) }).catch(e => logger.warn('[api] industry click track failed:', e)),
  // admin
  adminLogin: (pin) => request('/admin/login', { method: 'POST', body: JSON.stringify({ pin }) }),
  // chat
  chat: (data) => request('/chat/message', { method: 'POST', body: JSON.stringify(data) }),
  chatSessions: () => request('/chat/sessions'),
  chatMessages: (sessionId) => request(`/chat/messages${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`),
  // content
  insights: (params = {}) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v != null && v !== '')).toString();
    return request(`/insights${qs ? '?' + qs : ''}`);
  },
  insight: (slug) => request(`/insights/${slug}`),
  region: (code) => request(`/regions/${code}`),
  regions: () => request('/regions')
};
